import { Button } from 'primereact/button';
import styled, { css } from 'styled-components';

export const PcrListItem = styled.div<{ $selected: boolean; $disabled?: boolean }>`
  position: relative;
  padding: 1rem;
  cursor: auto;
  border: 1px solid ${(props) => props.theme.colors.elementsInputBorder};
  ${(props) =>
    props.$selected &&
    css`
      background-color: ${(props) => props.theme.colors.elementsTableRow};
      border-color: ${(props) => props.theme.colors.elementsTableRow};
    `}
  ${(props) =>
    props.$disabled &&
    css`
      background-color: #f8f8f8;
      border-color: #f8f8f8;
    `}
  ${(props) => props.theme.typography.bodyInput}
`;

export const PcrListItemHeader = styled.div<{ $disabled?: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  color: ${(props) => props.theme.colors.primaryBlack};
  ${(props) =>
    props.$disabled &&
    css`
      opacity: 0.5;
    `}
`;

export const DownloadButton = styled(Button)`
  height: 1.5rem;
  margin-top: 16px;
  padding: 0.25rem 0.5rem;
  border-radius: 2px;
  .pi {
    font-size: 0.75rem;
  }
  ${(props) => props.theme.typography.buttonButtonSmall}
`;

export const DialogContentContainer = styled.div`
  padding: 0.25rem 2rem 1rem 2rem;
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
`;
